import { observer } from 'mobx-react-lite'

export const CommonComponents = observer(() => {
  return <>{/*<StripeCoupon />*/}</>
})
